export enum RestoreOption {
	DeviceInformation,
	RoomInformation,
	AudioRoutingInformation,
	DeviceAssociationInformation,
	ControlRouteInformation
}
